import firebase from "firebase/app";
import "firebase/database";
import "firebase/storage";
import "firebase/auth";

const config = {
  apiKey: "AIzaSyDpCD-T7nmOno6U3k6BDYi37GY7vEatLxU",
  authDomain: "reactcms-f392a.firebaseapp.com",
  databaseURL: "https://reactcms-f392a.firebaseio.com",
  projectId: "reactcms-f392a",
  storageBucket: "reactcms-f392a.appspot.com",
  messagingSenderId: "103842277556"
};

firebase.initializeApp(config);

export default firebase;



// WEBPACK FOOTER //
// ./src/firebase.js